"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthFileType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const AuthFileType = exports.AuthFileType = _propTypes.default.shape({
  msalConfig: _propTypes.default.shape({
    auth: _propTypes.default.shape({
      clientId: _propTypes.default.string,
      authority: _propTypes.default.string,
      redirectUri: _propTypes.default.string,
      postLogoutRedirectUri: _propTypes.default.string,
      navigateToLoginRequestUrl: _propTypes.default.bool
    }),
    cache: _propTypes.default.shape({
      cacheLocation: _propTypes.default.string,
      storeAuthStateInCookie: _propTypes.default.bool
    }),
    system: _propTypes.default.shape({
      loggerOptions: _propTypes.default.shape({
        loggerCallback: _propTypes.default.func
      })
    })
  }).isRequired,
  loginRequest: _propTypes.default.shape({
    scopes: _propTypes.default.arrayOf(_propTypes.default.string)
  }).isRequired
});